import { flushSync } from 'react-dom'

type DocComViewTransition = Document & {
  startViewTransition?: (cb: () => void) => unknown
}

export function prefereMenosMovimento(): boolean {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
}

export function comTransicao(aplicar: () => void): void {
  const iniciar = (document as DocComViewTransition).startViewTransition?.bind(document)

  if (!iniciar || prefereMenosMovimento()) {
    aplicar()
    return
  }

  iniciar(() => flushSync(aplicar))
}
